import * as angular from 'angular';
import { getGuid } from './getGuid';

export class Helper {
    private static colors = ['#c36', '#39c', '#939', '#990', '#f93', '#099', '#f9c', '#6cf', '#c9c', '#cc0', '#fc3', '#6cc'];
    private static symbols = ['circle', 'cross', 'diamond', 'square', 'triangle-down', 'triangle-up'];

    static getApp(): angular.IModule {
        return angular.module('app');
    }

    static getGuid(): string {
        return getGuid();
    }

    static getColor(index: number): string {
        return Helper.getItem(Helper.colors, index);
    }

    static getSymbol(index: number): string {
        return Helper.getItem(Helper.symbols, index);
    }

    static getSymbols(): string[] {
        return Helper.symbols;
    }

    static getRegExp(expression: string): RegExp {
        return Helper.getRegExpCase(expression, false);
    }

    static getDictionnary<T>(values: { key: string, value: T }[]): { [key: string]: T } {
        const ret = {};
        values.forEach(v => ret[v.key] = v.value);
        return ret;
    }

    static getRegExpCase(expression: string, caseInsensitive: boolean): RegExp {
        try {
            if (!expression) {
                return undefined;
            }
            if (expression.indexOf('*') < 0 && expression.indexOf('?') < 0) {
                expression = `*${expression}*`;
            }
            const pattern = expression
                .split('*')
                .join('[\\s|\\S]*')
                .split('?')
                .join('[\\s|\\S]');
            return caseInsensitive ? new RegExp(`^(${pattern})$`, 'i') : new RegExp(`^(${pattern})$`);
        } catch (e) {
            console.log(e);
        }
    }

    private static getItem(collection, index) {
        while (index >= collection.length) {
            index -= collection.length;
        }
        return collection[index];
    }
}